<svelte:options accessors/>
<script lang="ts">
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import {createEventDispatcher} from "svelte";
    import {getFormatter} from "../../utils";
    import Alerta from "./Alerta.svelte";

    export let total: number = 0;
    export let link: string = ''
    const dispatch = createEventDispatcher();
    const formatter = getFormatter();
    export let alertMessages = [];

    function detalles() {
        dispatch('details');
    }

    function pay() {
        dispatch('pay');
    }

    $: disabled = (total <= 0);
    $: caption = link && !disabled ? 'Continuar a pago' : 'Generando enlace';
</script>

<section class="payment-bar py-ii mt-1">
    <div class="px-2">
        {#if disabled }
            <Alerta title="ATENCIÓN:"
                    message="El valor total a pagar debe ser mayor a 0. Revise su selección para continuar."/>
            <!--
                Seleccione los saldos a pagar en orden de vencimiento del más antiguo hacia adelante.
            -->
            <!--
                1. Debe mostrar juntos siempre los diferentes endosos por No. de póliza.
                2. Debe priorizar los registros de acuerdo a la que tenga fecha de vencimiento de alguno de sus pagos más próximo pero sin romper la regla 1.
                3. En esta misma pantalla el usuario está consultando: pólizas, endosos, preliquidaciones y saldos negativos (saldos a favor del usuario)

                Adicional al seleccionar se debe tener en cuenta que solo me debe dejar seleccionar los saldos a pagar
                desde el más antiguo al más reciente y siguiendo los consecutivos de los endosos y no. de cuota.
                Ej: No me deja seleccionar endoso 19 y luego 21 sino que debo seleccionarlos en orden (igual con las
                cuotas). Si trato de seleccionarlos debe salir un tooltip como este:

                "Seleccione los saldos a pagar en orden de vencimiento del más antiguo hacia adelante"
            -->
        {/if}
        {#each alertMessages as message}
            <Alerta title="ATENCIÓN:"
                    {message}/>
        {/each}

        <div class="box-r sx-3 items-center">
            <div class="text-c">
                <div class="border radius py-ii px-1">Total a pagar <strong>{formatter(total)}</strong></div>
            </div>
            <div class="box-r sx-ii">
                <NauiButton className="min-w-200px" caption="Ver detalles" mode="outline" color="accent"
                            on:click={detalles}/>
                <NauiButton disabled="{disabled || !link}" className="min-w-200px" caption="Continuar a pago"
                            mode="solid" color="accent"
                            href="{link}" target="_blank" on:click={pay}/>
            </div>
        </div>
    </div>
</section>
<style>
    .gridPaymentBar {
        display: grid;
        grid-template-columns: 400px auto auto;
        grid-gap: 1rem;
    }
</style>